// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__1RrqN","content":"GlobalSearch_content__36-Gx"};